export const toggleAppLoader = (showed: boolean) => {
  document
    .getElementById('app_loader')
    ?.classList.toggle('loader_hidden', !showed)
}
